/* eslint-disable no-magic-numbers -- enum values are pinned to
   @fulcrum/cdm-components PropType/PropInputType so both packages classify
   identically; the literals ARE the contract. */

/**
 * Structural classification of a custom pset property, mirroring tcweb's
 * `@fulcrum/cdm-components` `PropType`. Numeric values are kept in sync with
 * that package so downstream display formatting behaves identically.
 */
export enum CustomPropertyType {
  Unknown = 0,
  SingleValue = 1,
  SingleEnumValue = 2,
  ListValue = 3,
  Logical = 4,
  AutoCalculate = 5,
}

/**
 * Data-type of a custom pset property used to pick a formatter, mirroring
 * tcweb's `@fulcrum/cdm-components` `PropInputType`. For list properties this
 * describes the item type.
 */
export enum CustomPropertyInputType {
  Unknown = 0,
  Text = 1,
  NumericWhole = 2,
  NumericDecimal = 3,
  Logical = 4,
  Boolean = 5,
  Date = 6,
  DateTime = 7,
  Duration = 8,
  LengthMeasure = 9,
  AreaMeasure = 10,
  VolumeMeasure = 11,
  MassMeasure = 12,
  AngleMeasure = 13,
  URI = 14,
  Query = 15,
}

/* eslint-enable no-magic-numbers */

export type CustomPsetScalarValue =
  | string
  | number
  | bigint
  | boolean
  | { high: number; low: number };

export type CustomPsetPropertyValue =
  | CustomPsetScalarValue
  | readonly CustomPsetScalarValue[]
  | undefined
  | null;

export interface CustomPsetInstanceProperty {
  id: string;
  value: CustomPsetPropertyValue;
  /** Structural classification (single / list / logical / enum / …). */
  propType: CustomPropertyType;
  /** Data-type used to format the value (or list items). */
  inputType: CustomPropertyInputType;
  enumOptions?: readonly string[];
  required?: boolean;
}

export interface CustomPsetInstance {
  link: string;
  libId: string;
  defId: string;
  psetName: string;
  version: number;
  properties: Record<string, CustomPsetInstanceProperty>;
}

export interface ListCustomPsetInstancesParams {
  links: readonly string[];
}

export interface CustomPsetReadActions {
  listInstances(
    params: ListCustomPsetInstancesParams
  ): Promise<CustomPsetInstance[]>;
}
